window.onload = function() {
  // Aria-hidden tracking pixels
  setTimeout(function() {
    var pxImages = document.querySelectorAll('img[src*="r.turn"], img[src*="wt.soundest"]');
    if (pxImages !== undefined && pxImages !== null) {
      for (var i = 0; i < pxImages.length; i++) {
        pxImages[i].setAttribute('aria-hidden','true');
        pxImages[i].setAttribute('alt', 'pixel');
      }
    }
  }, 1000);


  // Add aria-labels to shoppable instagram slider
  setTimeout(function () {
    if (document.querySelector('.ssw-prev') !== null) {
      document.querySelector('.ssw-prev').setAttribute('aria-label', 'Previous Slide');
    }

    if (document.querySelector('.ssw-next') !== null) {
      document.querySelector('.ssw-next').setAttribute('aria-label', 'Next Slide');
    }
  }, 1500);
  
  setTimeout(function() {
    var instagramImages = document.querySelectorAll('.ssw-item-by a[target="_blank"] > img');
    if (instagramImages !== null && instagramImages !== undefined) {
      for (var i = 0; i < instagramImages.length; i++) {
        instagramImages[i].setAttribute('alt','Jetty Instagram Image');
      }
    }
  }, 2000);

};